import dayjs from "dayjs"
import { DocumentData, QueryDocumentSnapshot } from "firebase/firestore"
import { Buyer } from "../Type"

export const getBuyerFromDocSnapshot = (
  doc: QueryDocumentSnapshot<DocumentData, DocumentData>
): Buyer => {
  return {
    id: doc.id,
    name: doc.data().name,
    address: doc.data().address,
    phone: doc.data().phone,
    email: doc.data().email,
    website: doc.data().website,
    insertDate: dayjs().valueOf(),
    lastEditDate: dayjs().valueOf(),
  }
}
